import { URL_API } from "../../../general/init/url";

export const API_METHOD_INFO = URL_API;
export const API_LIST_UID = URL_API;
export const API_START_RECORD = (projectCode, sessionId) =>
  URL_API +
  "/api/project/assessmentMethodSession/" +
  projectCode +
  "/" +
  sessionId +
  "/startRecording";

export const API_SET_PRIVATE_NOTE = (projectCode) =>
  URL_API +
  "/api/project/assessmentMethodSession/" +
  projectCode +
  "/assessorNote";
export const API_GET_PRIVATE_NOTE = (projectCode) =>
  URL_API +
  "/api/project/assessmentMethodSession/" +
  projectCode +
  "/assessorNote";

export const API_SET_ANSWER_ASSESSEE = (projectCode, sessionName) =>
  URL_API +
  "/api/project/assessmentMethodSession/" +
  projectCode +
  "/" +
  sessionName +
  "/assesseeSubmission";
export const API_GET_ANSWER_ASSESSEE = () => URL_API + "";
export const API_GET_LIST_ANSWER_ASSESSEE = (projectCode, sessionName) =>
  URL_API +
  "/api/project/assessmentMethodSession/" +
  projectCode +
  "/" +
  sessionName +
  "/assesseeSubmissionList";

export const API_GET_ASSESSOR_GUIDE = () =>
  URL_API + "/api/project/testBattery/methodGuideline";
export const API_GET_ASSESSEE_GUIDE = () =>
  URL_API + "/api/project/testBattery/methodGuideline";
export const API_GET_ASPECT_GUIDE = () =>
  URL_API + "/api/project/testBattery/aspectsOnMethod";

export const API_SET_END_SESSION = (projectCode, sessionName) =>
  URL_API +
  "/api/project/assessmentMethodSession/" +
  projectCode +
  "/" +
  sessionName +
  "/closeSession";
